import styled from "@emotion/styled";

export const NotFound = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

export const NotFoundContainer = styled.div`
  width: 500px;
  height: 500px;
`;
